import request from '@/plugin/axios';
export function saveAlarmItem(params) {
  return request({
    url: '/admin/alarm/item/save',
    method: 'post',
    params: params
  });
}
export function deleteAlarmItem(params) {
  return request({
    url: '/admin/alarm/item/delete',
    method: 'post',
    params: params
  });
}